import { CrudApi } from './CrudApi';
import { TargetedSharingModel } from '@/models/targetedSharing/TargetedSharingModel';

export class TargetedSharingApi extends CrudApi<TargetedSharingModel> {
	constructor() {
		super(`targetedSharing`, (obj) => new TargetedSharingModel().load(obj));
	}
}

export const targetedSharingApi = new TargetedSharingApi();